export class PrizeDelivery {
  is_id_required: boolean;
  is_waiting: boolean;
  idv_attempt_link: string;
  slug: string;
  user_awaiting_deliveries: UserAwaitingDeliveries[];
  failed_message: string;
  has_failed: boolean;
}

export class UserAwaitingDeliveries {
  cash_alternative_value: null;
  credit_alternative_value: null;
  extra_cash: number;
  draw_date: null;
  email: string;
  full_name: string;
  phone_number: string;
  postal_full_name: string;
  postal_address1: string;
  postal_address2: string;
  postal_city: string;
  postal_state: string;
  postal_postcode: string;
  postal_country: string;
  postal_country_id: number;
  postal_phone_code: string;
  postal_phone: string;
  postal_phone_full: string;
  postal_email: string;
  prize_name: string;
  sub_prize_name: string;
  prize_type: PrizeType;
  raffle_title: string;
  raffle_id: string;
  slug: string;
  ticket_number: string;
  ticket_numeric: number;
  confirmed?: boolean;
}

export enum PrizeType {
  CREDIT = 'credit',
  VOUCHER = 'voucher',
  CASH_AUTO = 'cash-auto',
  CASH_MANUAL = 'cash-manual',
  SHIPPING = 'item-shipping',
  TERMINAL = 'item-terminal',
  TECH = 'item-tech',
  PERSONAL = 'item-personal-collection',
  PERSONAL_EXTRA = 'item-personal-collection-plus-extra-cash',
  SHIPPING_EXTRA = 'item-shipping-plus-extra-cash'
}

export enum PayoutType {
  UK = 'uk',
  IBAN = 'iban'
}
